/**
 * @desc undefined
 */
import { UnfamiliarForm } from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type SaveUnfamiliarParameter = UnfamiliarForm

const method = 'POST'
const url = '/trade/unfamiliar'

export const saveUnfamiliarApi = (
  data?: SaveUnfamiliarParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<any>({
    method,
    url,
    data,
    ...config
  })
}

saveUnfamiliarApi.method = method
saveUnfamiliarApi.url = url
